// 远程监理相关
const LongContract = () => import('@/pages/personalCenter/longPage/longContract.vue')
const NodeList = () => import('@/pages/personalCenter/longPage/nodeList.vue')
const UploadRetest = () => import('@/pages/personalCenter/longPage/uploadRetest.vue')
const RetestDetails = () => import('@/pages/personalCenter/longPage/retestDetails.vue')

export default [

  {
    path: '/personalCenter/longPage/longContract',
    name: '远程合同',
    component: LongContract,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/longPage/nodeList',
    name: '节点复验',
    component: NodeList,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/longPage/uploadRetest',
    name: '复验上传',
    component: UploadRetest,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },
  {
    path: '/personalCenter/longPage/retestDetails',
    name: '复验详情页',
    component: RetestDetails,
    meta: {
      headerShow: true,
      footerShow: false,
      sidebarShow: false,
    }
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/longRouter.js